import { ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import Logo from './Logo';

const FOOTER_SERVICES = [
  { label: 'Logo & Brand Identity', to: '/services/logo-brand-identity' },
  { label: 'Website Design', to: '/services/website-design' },
  { label: 'Social Media Marketing', to: '/services/social-media-marketing' },
  { label: 'SEO & Performance', to: '/services/seo-performance-marketing' },
];

const FOOTER_EXPLORE = [
  { label: 'Work', to: '/#work', anchor: true },
  { label: 'Sports Management', to: '/sports-management' },
  { label: 'Ralli — Pickleball App', to: '/ralli' },
  { label: 'Matchmaker', to: '/matchmaker' },
  { label: 'Insights', to: '/insights' },
  { label: 'Playbooks', to: '/playbooks' },
  { label: 'Careers', to: '/#careers', anchor: true },
  { label: 'Locations · San Diego', to: '/locations/san-diego' },
  { label: 'Locations · Carlsbad', to: '/locations/carlsbad' },
  { label: 'Locations · Las Vegas', to: '/locations/las-vegas' },
  { label: 'Contact', to: '/#contact', anchor: true },
];

function FooterLink({ item }) {
  if (item.anchor) {
    return (
      <a href={item.to} className="text-white/75 hover:text-[#FF3D2E] transition-colors text-sm">
        {item.label}
      </a>
    );
  }
  return (
    <Link to={item.to} className="text-white/75 hover:text-[#FF3D2E] transition-colors text-sm">
      {item.label}
    </Link>
  );
}

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 overflow-hidden" data-testid="site-footer">
      {/* Marquee */}
      <div className="py-10 md:py-16 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee-fast font-display text-[18vw] md:text-[12vw] leading-none tracking-tight">
          {Array.from({ length: 6 }).map((_, i) => (
            <span key={i} className="mx-6 flex items-center gap-8">
              <span className="text-white">LET'S TALK</span>
              <span className={i % 2 === 0 ? 'outline-text' : 'text-white'}>—</span>
            </span>
          ))}
        </div>
      </div>

      <div className="px-5 md:px-10 lg:px-14 pb-10 pt-6 border-t border-white/5">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="mb-6">
              <Logo size="lg" showWordmark={false} />
            </div>
            <p className="text-[11px] tracking-[0.3em] text-white/45">© 2026 SMG MEDIA GROUP</p>
            <p className="mt-2 text-white/65">Carlsbad, CA · Nashville, TN</p>
            <p className="mt-4 text-white/50 text-sm max-w-xs leading-relaxed">
              Logo design, website design, social media marketing, SEO, and co-brand
              partnerships for lifestyle and challenger brands.
            </p>
            <div className="mt-6 pt-6 border-t border-white/10 max-w-xs">
              <p className="text-[10px] tracking-[0.3em] text-white/45 mb-2">SMG SPORTS MANAGEMENT</p>
              <p className="text-white/70 text-sm mb-1">Pickleball-focused athlete representation.</p>
              <a href="tel:+16195524677" className="block text-white/65 hover:text-white text-sm transition-colors" data-testid="footer-sports-phone">
                +1 (619) 552-4677
              </a>
              <a href="mailto:repme@smgsportsmgt.com" className="block text-white/65 hover:text-white text-sm transition-colors" data-testid="footer-sports-email">
                repme@smgsportsmgt.com
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.3em] text-white/45 mb-5">SERVICES</p>
            <ul className="space-y-3">
              {FOOTER_SERVICES.map((s) => (
                <li key={s.to}>
                  <FooterLink item={s} />
                </li>
              ))}
            </ul>
          </div>

          {/* Explore */}
          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.3em] text-white/45 mb-5">EXPLORE</p>
            <ul className="space-y-3">
              {FOOTER_EXPLORE.map((e) => (
                <li key={e.to}>
                  <FooterLink item={e} />
                </li>
              ))}
            </ul>
          </div>

          {/* Social — all three brands, stacked so visitors can follow any */}
          <div className="md:col-span-2 flex flex-col gap-7">
            <SocialLinks brand="smg" />
            <SocialLinks brand="sports" />
            <SocialLinks brand="ralli" />
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group inline-flex items-center gap-2 text-[11px] tracking-[0.3em] text-white/70 hover:text-white w-fit"
            >
              BACK TO TOP
              <ArrowUp className="w-3.5 h-3.5 group-hover:-translate-y-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
